import { render, staticRenderFns } from "./node_form.vue?vue&type=template&id=fb853c90&scoped=true&"
import script from "./node_form.vue?vue&type=script&lang=js&"
export * from "./node_form.vue?vue&type=script&lang=js&"
import style0 from "./node_form.vue?vue&type=style&index=0&id=fb853c90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb853c90",
  null
  
)

export default component.exports